module.exports = __webpack_public_path__ + "img/NO.36121ca6.png";